import React, { useState, useContext, useEffect } from "react";
import infJoin from "../../../Image/infJoin.png";
import { useLocation, useNavigate } from "react-router-dom";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import { Placeholder } from "rsuite";
import { Notification, useToaster } from "rsuite";
import CustomLoader from "../../comman/Loader/CustomLoader";
import FacebookLogin from "react-facebook-login";
import backButton from "../../../Image/backButton.svg";
import dreamstars_logo from "../../../Image/dreamstars_logo.png";
import facebook from "../../../Image/facebook.png";
import inst from "../../../Image/insta.png";
import checkmark from "../../../favicon/checkmark.svg";
import Footer from "../../comman/Footer";
import PagesModal from "./PagesModal";
import { Auth } from "../../../Contexts/AuthContext";
import secureHash from "../../../Helpers/secureHash";

const ConnectSocialPlatform = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [facebookAccessToken, setFacebookAccessToken] = useState("");
  const [isFbAdded, setIsFbAdded] = useState(false);
  const [isIgAdded, setIsIgAdded] = useState(false);
  const [influencer, setInfluencer] = useState();
  const [accessData, setAccessData] = useState();
  const [showPageModal, setShowPageModal] = useState(false);
  const [myPages, setMyPages] = useState([]);
  const { setAuth } = useContext(Auth);
  const [validataionErrors, setValidataionErrors] = useState([]);
  const toaster = useToaster();
  

  useEffect(() => {
    if (location?.state?.influencer_id) {
      getInfluencer();
    }
    setIsLoading(false);
  }, [location]);

  const getInfluencer = () => {
    setIsLoading(true);
    let confing = {
      url: `${ApiUrl.getInfluencer}/${location?.state?.influencer_id}`,
      method: "GET",
      body: {},
    };

    APIRequest(
      confing,
      (res) => {
        setIsLoading(false);
        setInfluencer(res?.influencer);
        setIsFbAdded(res?.is_facebook_added);
        setIsIgAdded(res?.is_instagram_added);
      },
      (err) => {
        setIsLoading(false);

        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
        } else if (err.response.status === 401 || 444) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        }
      }
    );
  };

  const handleFacebookIntegration = (data, type) => {
    setIsLoading(true);
    let confing = {
      url: ApiUrl.getFacebookPages,
      method: "POST",
      body: { ...data, provider: type },
    };

    APIRequest(
      confing,
      (res) => {
        setIsLoading(false);
        setMyPages(res?.pages);
        setFacebookAccessToken(res?.longLivedtoken);
        setAccessData(res?.access_data);
        setShowPageModal(true);
      },
      (err) => {
        setIsLoading(false);
        // setShowBasicForm(false);
        setShowPageModal(false);

        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
          console.log(err);
        } else if (err.response.status === 401 || 444) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        } else {
          alert(err?.message);
        }
      }
    );
  };

  const completeSignUp = () => {
    let confing = {
      url: `${ApiUrl.completeSignUp}`,
      method: "POST",
      body: {
        ...influencer,
        secureHash: secureHash.generate(influencer),
      },
    };

    APIRequest(
      confing,
      (res) => {
        setIsLoading(false);
        navigate("/campaigns");
        localStorage.setItem("token", res?.token);
        localStorage.setItem("user", JSON.stringify(res.user));
        localStorage.setItem("userRole", "INFLUENCER");
        setAuth({
          userRole: "INFLUENCER",
          user: res.user,
          token: res?.token,
        });
        window.location.reload();
      },
      (err) => {
        setIsLoading(false);

        if (err.response.status === 422) {
          setValidataionErrors(err.response.data.errors);
        } else if (err.response.status === 401 || 444) {
          toaster.push(
            <Notification type="error" header="Error">
              <Placeholder.Paragraph
                style={{ width: 100, color: "red" }}
                rows={0}
              />{" "}
              {err?.response?.data?.message}
            </Notification>,
            {
              placement: "topEnd",
            }
          );
        }
      }
    );
  };

  const handleSocialLogin = (res, type) => {
    if (res?.status === "unknown") {
      alert("Login cancelled");
    } else {
      handleFacebookIntegration(res, type);
    }
  };
  const alreadyAdded = (type) => {
    toaster.push(
      <Notification type="warning" header="Warning">
        <Placeholder.Paragraph style={{ width: 100, color: "red" }} rows={0} />{" "}
        {`${type} account is already linked`}{" "}
      </Notification>,
      {
        placement: "topEnd",
      }
    );
  };

  const socialDetails = () => {
    return (
      <>
        <form className="login-form  flex flex-col items-center justify-center w-[300px] sm:w-[440px] lg:w-[480px] font-museob ">
          <div
            className="flex items-center rounded-lg w-full h-[47px] relative"
            style={{
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
            }}
          >
            <div
              className=" w-[15%] lg:w-[10%] bg-[#FCAF45] 
              h-full absolute rounded-lg flex justify-center items-center"
            >
              <img alt={"intagram-logo"} src={inst} className="w-6"></img>
            </div>
            <div className="w-full h-full rounded-lg rounded-r-lg bg-gradient-to-r from-[#FCAF45] via-[#F56040] to-[#C13584]">
              <FacebookLogin
                appId="807529897062147"
                autoLoad={false}
                textButton={`${
                  isIgAdded
                    ? "Instagram account is linked"
                    : "Link your Instagram Bussiness account"
                }`}
                fields="name,email"
                isDisabled={isIgAdded}
                callback={(res) => {
                  isIgAdded
                    ? alreadyAdded("INSTAGRAM")
                    : handleSocialLogin(res, "INSTAGRAM");
                }}
                cssClass="facebook-button-class-insta-fb"
              />
            </div>
            {isIgAdded && (
              <div
                className="rounded-lg absolute right-0 rounded-l-lg h-[45px] w-[15%] lg:w-[10%] bg-gradient-to-b from-[#C13584] via-[#F56040] to-[#FCAF45]
             flex justify-center items-center"
              >
                <img
                  alt={"checkmark-logo"}
                  src={checkmark}
                  className="w-6"
                ></img>
              </div>
            )}
          </div>

          <div
            className="flex mt-3  items-center rounded-lg  w-full h-[47px] relative"
            style={{
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
            }}
          >
            <div className=" absolute rounded-lg h-full w-[15%] lg:w-[10%] bg-[#12A5FF] flex justify-center items-center">
              <img alt="facebook_logo" src={facebook} className="w-3"></img>
            </div>
            <div className=" w-full h-full rounded-lg rounded-r-lg bg-[#12A5FF] text-white">
              <FacebookLogin
                appId="807529897062147"
                autoLoad={false}
                textButton={`${
                  isFbAdded
                    ? "Facebook page is linked"
                    : "Link your Facebook page "
                }`}
                isDisabled={isFbAdded}
                fields="name,email"
                callback={(res) => {
                  isFbAdded
                    ? alreadyAdded("FACEBOOK")
                    : handleSocialLogin(res, "FACEBOOK");
                }}
                cssClass="facebook-button-class-insta-fb"
              />
            </div>
            {isFbAdded && (
              <div className="rounded-lg right-0 absolute rounded-l-lg h-[47px] w-[15%] lg:w-[10%] bg-[#12A5FF] flex justify-center items-center">
                <img alt="checkmark_logo" src={checkmark} className="w-6"></img>
              </div>
            )}
          </div>
          {(isFbAdded || isIgAdded) && (
            <span
              onClick={(e) => {
                completeSignUp(e);
              }}
              style={{
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px",
              }}
              className="i btn-anim bg-[#00B048] px-[60px] py-[10px] rounded-lg  mt-7 text-white font-museobb cursor-pointer"
            >
              CONTINUE
            </span>
          )}
        </form>
      </>
    );
  };

  const handleBack = () => {
    navigate("/influencer-signin");
  };

  return (
    <>
      <CustomLoader visible={isLoading} />
      <div
        style={{ backgroundImage: `url(${infJoin})` }}
        className="relative max-w-screen min-h-screen font-museo bg-cover bg-center bg-no-repeat flex flex-col  items-center justify-center  "
      >
        <img
          alt="back_btn"
          onClick={handleBack}
          src={backButton}
          className=" cursor-pointer absolute top-5 left-8"
        />

        <div className="absolute md:top-10 top-16 header-form font-museob flex flex-col items-center justify-center ">
          <p className="font-museob text-black text-4xl relative -bottom-3 ">
            Join
          </p>
          <img
            alt="dreamstar_logo"
            src={dreamstars_logo}
            className="w-[50%] my-2  ml-8 "
          ></img>
          <p className="text-black text-4xl ">
            I'm a <span className="font-museobb ">Influencer</span>
          </p>
        </div>
        {socialDetails()}
        <PagesModal
          showModal={showPageModal}
          influencer_id={influencer?.id}
          setShowModal={() => {
            setShowPageModal(!showPageModal);
            getInfluencer();
          }}
          myPages={myPages}
          facebookAccessToken={facebookAccessToken}
          accessData={accessData}
        />

        <div className="absolute bottom-0">
          <Footer colorClass="footerColor2" clas="footer" />
        </div>
      </div>
    </>
  );
};

export default ConnectSocialPlatform;
